module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-15-3f55a3f98fab93f843bd7ec0a6e5f034.svg";